import React from 'react'
import API from "../base/API";
import { setUser } from "./Auth";
import Storage from "../base/Storage";

/*eslint no-restricted-globals: 0 */

export default class Login extends React.Component {
    constructor(props) {
        super(props);

        this.api = new API({
            auth: "/user/auth",
        });

        this.state = {
            loginData: {
                email: "",
                password: "",
            },
            error: false
        }
    }

    onSubmit(evt) {
        this.api.request({
            route: "auth",
            data: this.state.loginData,
            success: (response) => {
                setUser(response.user);
                Storage.set("atoken", response.key);
                location.reload();
            },
            error: (response) => {
                this.setState({ error: response.message });
            }
        });
        evt.preventDefault();
    }

    onChange(evt) {
        // Get data from state
        let newLoginData = this.state.loginData;

        // Update it's value
        newLoginData[evt.target.name] = evt.target.value;

        // Update data in state
        this.setState({ loginData: newLoginData });
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-4 col-md-offset-4">
                        <div className="login-panel panel panel-default">
                            <div className="panel-heading">
                                <h2 style={{ marginTop: 0, marginBottom: 0, textAlign: "center" }}>
                                    <img src="/static/img/wtlogo.png" alt="trend" className="img-responsive" style={{ height: "3rem", margin: "0 auto" }} />
                                </h2>
                            </div>
                            <div className="panel-body">
                                <form role="form" autoComplete={"false"} onSubmit={this.onSubmit.bind(this)}>
                                    <fieldset>
                                        <div className="form-group">
                                            <input type="email"
                                                className="form-control"
                                                placeholder="E-Mail"
                                                name="email"
                                                onChange={this.onChange.bind(this)}
                                                autoFocus={true} />
                                        </div>
                                        <div className="form-group">
                                            <input type="password"
                                                className="form-control"
                                                placeholder="Heslo"
                                                name="password"
                                                onChange={this.onChange.bind(this)} />
                                        </div>
                                        <input type="submit" className="btn btn-md btn-success btn-block" value="Prihlásiť" />
                                        {this.state.error ? <div className="alert alert-danger" style={{ marginTop: "2rem" }}>{this.state.error}</div> : ""}
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/auth/Login.js